<template>
    <div>

    <Cbarra>
        <template slot="slotTitle">Contacto</template>
        <template slot="slotRoute">
            <router-link :to="{name:'index'}">Inicio</router-link> / <router-link :to="{name:'contacto'}">Contacto</router-link>
        </template>
    </Cbarra>

    <section class="container justify-content-center">
        <div class="bg-principal-02">
            <div class="row justify-content-center">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <h5 class="mb-3 color_Azul">
                        Escuela Nacional de Estudios Superiores Unidad Mérida
                    </h5>
                    <p>
                        <b><i class="fas fa-map-marker-alt mr-2"></i> Dirección:</b> Tablaje Catastral N°6998, Carretera
                        Mérida-Tetiz Km. 4.5, Municipio de Ucú, Yucatán, México, C. P. 97357
                    </p>
                    <p><b><i class="far fa-phone-alt mr-2"></i> Teléfono:</b> 99 93 99 09 01</p>
                    <p>
                        <b><i class="far fa-envelope mr-2"></i> Correo:</b>
                        <a href="mailto:difusion@enesmerida.unam.mx">
                            difusion@enesmerida.unam.mx
                        </a>
                    </p>
                </div>
            </div>
        </div>
    </section>

    <section class="text-center">
        <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3725.1432885081426!2d-89.73673225104913!3d20.986892596121915!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f560c87b2bb0735%3A0x7c3a93a809085336!2sENES%20UNAM%20CAMPUS%20M%C3%89RIDA!5e0!3m2!1ses-419!2smx!4v1580769547307!5m2!1ses-419!2smx "
            width="100% " height="450 " frameborder="0 " style="border:0; " allowfullscreen=" ">
        </iframe>
    </section>

  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>